import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

/**
 * layout for displaying details in a column
 * @param {*} param0
 * @returns wrapper component
 */
const DetailLayout = ({ children, ...props }) => {
	return (
		<Stack
			sx={{ marginTop: '32px' }}
			direction='column'
			spacing={{
				xs: 0.5,
				sm: 0.5,
				md: 1,
			}}
			divider={<Divider orientation='horizontal' />}
			{...props}
		>
			{children}
		</Stack>
	);
};

export default DetailLayout;
